import gql from 'graphql-tag';

export const GET = gql`
  query getReview($input: GetReviewInput!) {
    getReview(input: $input) {
      id
      courseId
      userId
      content
      rate
      reviewer {
        id
        profilePath
        name
      }
      createdBy
      createdName
      createdTime
      updatedTime
    }
  }
`;

export const LIST = gql`
  query getReviewList($input: ReviewListInput!) {
    getReviewList(input: $input) {
      page
      totalPages
      total
      results {
        id
        courseId
        userId
        content
        rate
        isVerifiedPurchase
        reviewer {
          id
          profilePath
          name
        }
        createdTime
        updatedTime
      }
    }
  }
`;

export const SEARCH = gql`
  query searchReviews($input: SearchReviewsInput!) {
    searchReviews(input: $input) {
      totalItems
      items {
        id
        courseId
        userId
        content
        rate
        isVerifiedPurchase
        reviewer {
          id
          profilePath
          name
        }
        createdTime
        updatedTime
      }
    }
  }
`;

export const AVERAGE = gql`
  query averageReview($input: AverageReviewInput!) {
    averageReview(input: $input) {
      total
      rate
    }
  }
`;
